module.exports = __webpack_public_path__ + "img/qianxingyang.f6dd5ffd.png";